module.exports = __webpack_public_path__ + "img/F.e235e3ab.svg";